export const SAVE_OBSERVATION = 'SAVE_OBSERVATION'
export const FETCH_OBSERVATIONS = 'FETCH_OBSERVATIONS'
export const CREATE_OBSERVATION = 'CREATE_OBSERVATION'
export const GET_SINGLE_OBSERVATION = 'GET_SINGLE_OBSERVATION'
export const GET_OBSERVATION_COMMENTS = 'GET_OBSERVATION_COMMENTS'
export const CREATE_OBSERVATION_COMMENT = 'CREATE_OBSERVATION_COMMENT'
